import type { ReactNode } from "react";

import { toTitleCase } from "../../../utils/shared/strings";

/**
 * Modal subtitle that always names the target location when known.
 * Pass a ReactNode description so GeneralModal keeps tertiary chrome around
 * the emphasized location span.
 */
export const createAtLocationDescription = (
	locationName: string | undefined,
	copy: {
		fallback: string;
		withLocation: (location: ReactNode) => ReactNode;
	},
): ReactNode => {
	const trimmed = locationName?.trim();
	return (
		<p className="text-sm text-tertiary">
			{trimmed
				? copy.withLocation(
						<span className="font-semibold text-primary">
							“{toTitleCase(trimmed)}”
						</span>,
					)
				: copy.fallback}
		</p>
	);
};
